import util from '../util'

let controller = 'MonitorRelatorioConsolidadoCredito'

export default Object.assign({}, util.GetCrud(controller, ['get']), {
  GetAll (dto, options) {
    if (options && options.data) dto.data = options.data
    console.log(dto)
    return util.Axios.GetAll(controller, dto)
  },
  BaixarRelatorio (codigo) {
    return util.Axios.GetBlob(controller + `/BaixarRelatorio/${codigo}`, {})
  }
})
